import React, { useState } from 'react';
import { ISystemMailCategory } from '../../Interfaces/ISystemMailCategory';
import {
  Grid,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { ISystemMail_has_Dictionary } from '../../Interfaces/ISystemMail_has_Dictionary';
import { IDictionary } from '../../Interfaces/IDictionary';
import { IDictionaryEntry } from '../../Interfaces/IDictionaryEntry';
import { Add } from '@mui/icons-material';

interface IProps {
  systemMailCategories: ISystemMailCategory[];
  systemMailHasDictionary: ISystemMail_has_Dictionary[];
  dictionaries: IDictionary[];
  dictionaryEntries: IDictionaryEntry[];
}

export const SystemMailCategoryOverview: React.FC<IProps> = ({
  systemMailCategories,
  systemMailHasDictionary,
  dictionaries,
  dictionaryEntries,
}) => {
  const [editCategory, setEditCategory] = useState();
  return (
    <>
      <Typography variant='h4'>Konfiguration</Typography>
      <Grid container spacing={2}>
        <Grid item xs={6}>
          <Typography variant='h5'>
            Wörterbücher
            <IconButton sx={{ float: 'right' }}>
              <Add />
            </IconButton>
          </Typography>
          <Table>
            <TableHead>
              <TableCell width={50}>Nr.</TableCell>
              <TableCell>Wörterbuch</TableCell>
            </TableHead>
            <TableBody>
              {dictionaries.map(dict => (
                <TableRow
                  key={`row-dictionary-${dict.idDictionary}`}
                  sx={{
                    cursor: 'pointer',
                    '&:hover': { background: '#f5f5f5' },
                  }}
                >
                  <TableCell>{dict.idDictionary}</TableCell>
                  <TableCell>{dict.Dictionary}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Grid>
        <Grid item xs={6}>
          <Typography variant='h5'>
            Kategorien
            <IconButton sx={{ float: 'right' }}>
              <Add />
            </IconButton>
          </Typography>
          <Table>
            <TableHead>
              <TableCell width={50}>Nr.</TableCell>
              <TableCell>Kategorie</TableCell>
            </TableHead>
            <TableBody>
              {systemMailCategories.map(cat => (
                <TableRow
                  key={`row-systemmailcategoriy-${cat.idSystemMailCategory}`}
                  sx={{
                    cursor: 'pointer',
                    '&:hover': { background: '#f5f5f5' },
                  }}
                >
                  <TableCell>{cat.idSystemMailCategory}</TableCell>
                  <TableCell>{cat.SystemMailCategory}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Grid>
      </Grid>
    </>
  );
};
